var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.79999 0.800049H7.19999V7.20005H0.799988V8.80005H7.19999V15.2H8.79999V8.80005H15.2V7.20005H8.79999V0.800049Z","fill":"black"}));
}

PlusSign.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
